module.exports = __webpack_public_path__ + "dist/media/bg_testimonials.d510bd77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_testimonials.png
// module id = 370
// module chunks = 0